export const API_CONSTANTS = {
  AUTH: '/authenicate',
  LOGIN: '/login',
  REGISTER: '/register',
  VETERAN: '/veteran',
  VETERANS: '/veterans',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/resetpassword',
  MILITARY_BENEFIT: '/militarybenefit',
  SPREAD_SHEET: '/spreadsheet',
  COLLEGE: '/college',
  COLLEGES: '/colleges',
  COLLEGE_ADMIN: '/collegeadmin',
  DEFAULT: '/default',
  SEARCH: '/search',
  COLLEGE_SEARCH: '/collegesearch',
  AUTO_LIST: '/autolist',
  LEVELS: '/levels',
  LEVEL: '/level',
  MAJORS: '/majors',
  BUCKETS_TITLE: '/buckets-title',
  MAJORS_LEVEL: '/majorslevel',
  BUCKET_LIST: '/bucketlist',
  COLLEGE_RANK: '/collegerank',
  RANK_LIST: '/ranklist',
  SECONDARY_BUCKET_LIST: '/secondarybucketlist',
  FILTER: '/filter',
  LEVEL_BUCKET: '/levelbucket',
  LEVEL_OBJECT: '/levelobject',
  COMPARISION: '/comparison',
  COLLEGE_MAJORS: '/collegemajors',
  IN_PERSON: '/in-person',
  ONLINE: '/online',
  DESIGNATION: '/designation',
  NEWS_FEED: '/newsfeed',
  TOP_AD: '/topad',
  SIDE_BAR_AD: '/sidebarad',
  LEGION: '/legion',
  POST: '/post',
  LEGION_POST: '/legionpost',
  STUDENT: '/student',
  MESSAGE_INFO: '/messageinfo',
  ACADEMIC_INTEREST: '/academicinterest',
  UPDATE: '/update',
  PROFILE_INFO: '/profileinfo',
  FILTER_DATA: '/filterdata',
  USAGE_STATISTICS: '/usagestatistics',
  FAVORITE_COLLEGE: '/favouritecollege',
  BRANCH: '/branch',
  RECON_MESSAGE: '/reconmessage',
  INBOX: '/inbox',
  INBOX_COUNT: '/inboxcount',
  REPLY_MESSAGE: '/replymessage',
  DELETE_MESSAGE: '/replymessage',
  BANNER: '/banner',
  LOGO: '/logo',
  MARK_READ: '/markread',
  PROFILE_VIEW: '/profileview',
  FAVORITE_LIST: '/favouritelist',
  SETTING: '/setting',
  EMAIL: '/email',
  COUNTER: '/counter',
  VIEW: '/view',
  SEARCH_COLLEGE: '/searchcollege',
  TIMELINE: '/timeline',
  DELETE: '/delete',
  SUPER_ADMIN: '/superadmin',
  LIST: '/list',
  MATCH: '/match',
  COLLEGE_LIST: '/collegelist',
  EMAIL_BOUNCE_BACK: '/emailbounceback',
  AUTO_SEND_EMAIL: '/autosendemail',
  NEW_USER: '/newuser',
  BUCKET_DATA: '/bucketdata',
  EMAIL_DATA: '/emaildata',
  BASIC_INFO: '/basicinfo',
  STATIC: 'static',
  NAG_EMAIL: '/nagemail',
  SUBSCRIPTION: '/subscription',
  EXIST: '/exist',
  TRACKING: '/tracking',
  META_DATA: '/metadata',
  MAJOR_LIST: '/majorlist',
  BUCKET_INFO: '/bucketinfo',
  COLLEGE_PROFILE: '/collegeprofile',
  CHECK_COLLEGE: '/checkcollege',
  COLLEGE_INFO: '/collegeinfo',
  MONTHLY_REPORT: '/monthlyreport',
  EXIST_BY: '/existby',
  COLLEGE_ID: '/collegeid',
  ADD: '/add',
  REVIEW: '/review',
  COLLEGE_MESSAGE: '/collegemessage',
  CHECK: '/check',
  DATA: '/data',
  DATA_LIST: '/datalist',
  BAH: '/bah',
  SUCCESS: '/success',
  PAY_CALCULATOR: '/pay-calculator',
};
